export enum BulkUpdateCardsActionTypes {
  UPDATING_BULK = 'set-cards/UPDATING_BULK',
  BULK_UPDATED = 'set-cards/BULK_UPDATED',
}
